import { Directive, HostListener, Input, output } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[inputFileDropZone]'
})
export class DropZoneDirective {
  @Input() dropZoneDisabled: boolean = false;
  readonly onFilesDropped = output<File[]>();

  @HostListener('dragover', ['$event'])
  public onDragOver(event: DragEvent): void {
    this.preventAndStopEventPropagation(event);
  }

  @HostListener('dragleave', ['$event'])
  public onDragLeave(event: DragEvent): void {
    this.preventAndStopEventPropagation(event);
  }

  @HostListener('drop', ['$event'])
  public onDrop(event: DragEvent): void {
    if (!this.dropZoneDisabled) {
      this.preventAndStopEventPropagation(event);
      try {
        const files = Array.from(event.dataTransfer?.files ?? []);
        if (files.length > 0) this.onFilesDropped.emit(files);
      } catch (e) {
        console.error(e);
      }
    }
  }

  private preventAndStopEventPropagation(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
  }
}
